import {
	Container,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import errorLanguageResource from "./lang-resource";

interface Props {
	error: Error;
}

const GenericError: React.FC<Props> = ({ error }) => {
	const lang = useLanguageResource(errorLanguageResource);

	console.error(error);
	return (
		<Container width="m" className="generic-error" data-test-id="generic-error">
			<h1>{lang.genericError.title}</h1>
		</Container>
	);
};

export default GenericError;
